import React from 'react';

interface TermsSectionProps {
  title: string;
  content: string | string[];
  index?: number;
}

export function TermsSection({ title, content, index }: TermsSectionProps) {
  const formattedTitle = index ? `${index}. ${title}` : title;
  
  return (
    <section className="mb-8">
      <h2 className="text-2xl font-bold mb-4">{formattedTitle}</h2>
      {Array.isArray(content) ? (
        <ul className="list-disc pl-6 space-y-2">
          {content.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      ) : (
        <p className="text-gray-800">{content}</p>
      )}
    </section>
  );
}